<!--
 * @Author: cmchiu
 * @Date: 2023-03-21 15:35:47
 * @LastEditTime: 2023-12-06 11:06:37
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\components\Banner\banner.vue
 * 
-->
<template>
    <el-carousel
        trigger="click"
        :autoplay="true"
        :interval="5000"
        :indicator-position="bannerLs && bannerLs.length > 1 ? '' : 'none'"
        :arrow="bannerLs && bannerLs.length > 1 ? 'hover' : 'never'"
    >
        <el-carousel-item v-for="banner in bannerLs" :key="banner.sno">
            <div class="banner w-100">
                <div
                    class="banner__item w-100"
                    style="background-repeat: no-repeat; background-position: right bottom"
                    :style="
                        banner.ItemImages && banner.ItemImages.length > 0
                            ? `background-image: url(${banner.ItemImages[0].location})`
                            : ''
                    "
                >
                    <router-link :to="{ path: '/banner/Post', query: { id: '0001', sno: banner.sno } }">
                        <div class="banner__text">
                            <h1 class="banner__title" v-text="banner.ItemTitle"></h1>
                            <p class="banner__description" v-text="banner.ItemSubTitle"></p>
                        </div>
                    </router-link>
                </div>
            </div>
        </el-carousel-item>
    </el-carousel>
</template>

<script>
import XEUtils from 'xe-utils'
import { getItemContent } from '@/api/common'

export default {
    name: 'cBanner',

    data() {
        return {
            configs: {
                loading: false,
            },
            MenuID: '0001',
            bannerLs: [],
            pages: {
                totalResult: 0, // 總筆數
                pageSize: 10, // 分頁大小
                pageCurrent: 1, // 目前頁次
            },
        }
    },

    created() {
        this.getMenuItemLs()
    },

    methods: {
        async getMenuItemLs(chgFilters) {
            const vm = this
            vm.configs.loading = true
            if (chgFilters) vm.pages.pageCurrent = 1 //當條件改變時, 將當前頁次改回第1頁
            let params = {
                MenuID: vm.MenuID,
                // ItemStatus: vm.filter.status,
                // Keyword: vm.filter.keyword,
                PageSize: vm.pages.pageSize,
                PageCurrent: vm.pages.pageCurrent,
            }
            await getItemContent(params)
                .then(res => {
                    // handle success
                    vm.bannerLs = [] //res.Items
                    XEUtils.arrayEach(res.Items, item => {
                        item.ItemImages = JSON.parse(item.ItemImages)
                        XEUtils.arrayEach(item.ItemImages, data => {
                            data.location = encodeURI(data.location)
                        })
                        item.ItemFiles = JSON.parse(item.ItemFiles)
                        XEUtils.arrayEach(item.ItemFiles, data => {
                            data.location = encodeURI(data.location)
                        })
                        vm.bannerLs.push(item)
                    })
                    let pages = vm.pages
                    pages.totalResult = res.TotalResult
                    if (Math.ceil(pages.totalResult / pages.pageSize) < pages.pageCurrent) {
                        pages.pageCurrent = 1
                    }
                })
                .catch(err => {
                    // handle error
                    vm.bannerLs = []
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.configs.loading = false
                })
        },

        /* pageChange({ currentPage, pageSize }) {
            let page = this.pages
            page.pageCurrent = currentPage
            page.pageSize = pageSize
            this.getMenuItemLs()
        }, */
    },
}
</script>

<style>
.el-carousel__arrow i {
    cursor: pointer;
    font-size: 20pt;
    font-weight: bold;
}
@media (min-width: 768px) {
    .el-carousel__container {
        height: 574px;
    }
}
@media (min-width: 768px) and (max-width: 1365px) {
    .el-carousel__container {
        height: 535px;
    }
}
@media (max-width: 767px) {
    .el-carousel__container {
        /* height: 520px; */
        height: 40vh;
    }
}
.el-carousel__indicators.el-carousel__indicators--horizontal {
    width: 100vw;
    text-align: center;
    left: unset;
    transform: unset;
}
</style>
